const layout = () => import('../../internal/dashboard/layoutV2.vue')
const certificates = () => import('./index.vue')

const certificatesRoutes = {
  component: layout,
  children: [
    {
      path: '/certificates/random',
      name: 'certificatesRandom',
      meta: {
        title: 'certificatesRandom',
        requiresAuth: true,
      },
      component: certificates,
    },
  ],
}

export default certificatesRoutes
